import {Description} from '@radix-ui/react-dialog';
import clsx from 'clsx';

import {Text} from '../Text';

type Props = React.ComponentPropsWithRef<typeof Text>;
export const DialogDescription = ({
  ref: forwardedRef,
  children,
  className,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLParagraphElement>;
}) => (
  <Description asChild>
    <Text
      {...props}
      className={clsx(className, 'text-slate11! text-sm')}
      ref={forwardedRef}
    >
      {children}
    </Text>
  </Description>
);

DialogDescription.displayName = 'DialogDescription';
